import { render } from "./LessonLayout.vue?vue&type=template&id=77b4e7e6"
import script from "./LessonLayout.vue?vue&type=script&lang=js"
export * from "./LessonLayout.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__